<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="12"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h5 class="card-title mb-50 mb-sm-0">
            Loyalty Members
          </h5>
        </div>

        <table class="table table-striped">
          <tr>
            <th>Total Members</th>
            <td>{{ loyaltyMembersSummary.totalMembers | number('0,0')  }}</td>
          </tr>
          <tr>
            <th>Privileged Members</th>
            <td>{{ loyaltyMembersSummary.privilegedMembers | number('0,0')  }}</td>
          </tr>
          <tr>
            <th>Standard Members</th>
            <td>{{ loyaltyMembersSummary.standardMembers | number('0,0')  }}</td>
          </tr>
          <tr>
            <th>Pending Members</th>
            <td>{{ loyaltyMembersSummary.pendingMembers | number('0,0')  }}</td>
          </tr>
          <tr>
            <th>Number of CUG</th>
            <td>{{ loyaltyMembersSummary.noOfCUG | number('0,0')  }}</td>
          </tr>
        </table>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import {mapActions} from "vuex";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      startDate:'all',
      endDate:'all',
      loyaltyMembersSummary:{
        totalMembers:0,
        privilegedMembers:0,
        standardMembers:0,
        pendingMembers:0,
        noOfCUG:0
      },
    }
  },
  mounted (){
    this.getLoyaltyMembersSummaryData();
  },
  methods: {
    ...mapActions(["getLoyaltyMembersSummary"]),

    getLoyaltyMembersSummaryData(){
      let self = this;
      this.getLoyaltyMembersSummary({startDate: this.startDate, endDate : this.endDate})
          .then(function (loyaltyMembersSummary) {
            console.log(loyaltyMembersSummary);

            self.loyaltyMembersSummary = loyaltyMembersSummary;

          })
          .catch(function (error) {


            if( typeof error.response.status != "undefined"){
              if(error.response.status == 401){
                location.replace("/login");
              }

            }
          })
    },
  }
  }
</script>
